<template>
  <Layout height-full>
    <div class="box">
      <index-filter class="box-filter" :on-filter="filter => applyFilter(filter)" />
      <index-list ref="list" class="box-list" @open-participant="openParticipantModal" />
    </div>
    <index-footer />

    <!-- Modal de Volumes do Participante -->
    <volumes-modal
      ref="volumesModal"
      :participant="selectedParticipant"
      :items="participantItems"
      @register-item="openRegisterModal"
      @return-item="openReturnModal"
      @close="closeVolumesModal"
    />

    <!-- Modal de Registrar Volume -->
    <register-modal
      ref="registerModal"
      :participant="selectedParticipant"
      :locations="locations"
      :item-types="itemTypes"
      @registered="onItemRegistered"
      @close="closeRegisterModal"
    />

    <!-- Modal de Confirmar Devolução -->
    <return-modal
      ref="returnModal"
      :item="selectedItem"
      :participant="selectedParticipant"
      :item-types="itemTypes"
      @returned="onItemReturned"
      @close="closeReturnModal"
    />
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import IndexFilter from '@/modules/storage/pages/index/index-filter'
import IndexFooter from '@/modules/storage/pages/index/index-footer'
import IndexList from '@/modules/storage/pages/index/index-list'
import VolumesModal from '@/modules/storage/pages/index/volumes-modal'
import RegisterModal from '@/modules/storage/pages/index/register-modal'
import ReturnModal from '@/modules/storage/pages/index/return-modal'
import { mapState, mapActions } from 'vuex'
import { STORAGE_MODULE } from '@/modules/storage'

export default {
  name: 'storage-index',
  components: {
    Layout,
    IndexFilter,
    IndexFooter,
    IndexList,
    VolumesModal,
    RegisterModal,
    ReturnModal
  },
  page: {
    title: 'Guarda Volumes'
  },
  data: function () {
    return {
      selectedParticipant: null,
      selectedItem: null
    }
  },
  computed: {
    ...mapState(STORAGE_MODULE, {
      locations: function (state) { return state.locations },
      itemTypes: function (state) { return state.itemTypes },
      participantItems: function (state) { return state.currentItems }
    })
  },
  methods: {
    ...mapActions(STORAGE_MODULE, [
      'loadLocations',
      'loadItemTypes',
      'loadParticipantItems',
      'clearCurrentParticipant'
    ]),
    applyFilter: function (filter) {
      this.$refs.list.filter(filter.search || null)
    },
    openParticipantModal: function (participant) {
      var self = this
      self.selectedParticipant = participant
      self.loadParticipantItems(participant.id).then(function () {
        self.$refs.volumesModal.open()
      })
    },
    closeVolumesModal: function () {
      this.clearCurrentParticipant()
    },
    openRegisterModal: function () {
      this.$refs.registerModal.open()
    },
    closeRegisterModal: function () {
      // Recarrega os itens do participante
      if (this.selectedParticipant) {
        this.loadParticipantItems(this.selectedParticipant.id)
      }
    },
    openReturnModal: function (item) {
      this.selectedItem = item
      this.$refs.returnModal.open()
    },
    closeReturnModal: function () {
      this.selectedItem = null
    },
    onItemRegistered: function (item) {
      // Recarrega os itens e volta pro modal de volumes
      var self = this
      if (self.selectedParticipant) {
        self.loadParticipantItems(self.selectedParticipant.id)
      }
      self.$refs.registerModal.close()
    },
    onItemReturned: function (item) {
      // Recarrega os itens e volta pro modal de volumes
      var self = this
      if (self.selectedParticipant) {
        self.loadParticipantItems(self.selectedParticipant.id)
      }
      self.$refs.returnModal.close()
    }
  },
  mounted: function () {
    // Carrega localizações e tipos de item
    this.loadLocations()
    this.loadItemTypes()
  }
}
</script>

<style scoped lang="scss">
.box {
  min-height: 100%;
  grid-auto-rows: min-content auto;
  .box-filter {
    margin-bottom: 24px;
  }
}
</style>
